import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ruta404',
  templateUrl: './ruta404.component.html',
  styleUrls: ['./ruta404.component.scss']
})
export class Ruta404Component implements OnInit {
  @Input() codigoError1:string='4'
  @Input() codigoError2:string='0'
  @Input() codigoError3:string='4'
  @Input() mensaje:string='Oops! No se encuentra la ruta.'
  constructor() { }

  ngOnInit(): void {
  }

}
